module.exports = __webpack_public_path__ + "assets/not-pregnant.3a009502.png";